export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.11.5-1054.51",
  commitId: "b2915ba14fcf2b6b3e369cc88efcce0372910199",
  commitTime: "2026-11-05T10:54:51.000Z",
});
